module.exports = __webpack_public_path__ + "image/article_solution_zw.jpg";